import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";

const CenteredPortraitWoWeAre = () => {
  const sitedata = useSelector((store) => store.global.loginData);
  const [homeIntroData, setHomeIntroData] = useState({});

  useEffect(() => {
    getHomeIntroData();
  }, []);

  const getHomeIntroData = async () => {
    const response = await SendPostRequest("content/aboutus");
    setHomeIntroData(response?.data);
  };

  const contentArray = homeIntroData?.who_we_are_content || [
    {
      title: "Our Philosophy",
      description: [
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Excepturi facere earum quis ipsa vitae qui minima esse ducimus dolorum iste nisi laborum repellat dolores dolore debitis adipisci nemo quia autem pariatur a voluptatem dignissimos maiores accusantium nobis tempora consequatur cumque quas ea doloribus deleniti.",
        "Quibusdam commodi laboriosam error temporibus iste ipsa soluta distinctio maiores ad totam beatae incidunt veritatis enim? Reiciendis voluptate assumenda quidem eos explicabo rerum. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod.",
      ],
    },
    {
      title: "Our History",
      description: [
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Excepturi facere earum quis ipsa vitae qui minima esse ducimus dolorum iste nisi laborum repellat dolores dolore debitis adipisci nemo quia autem pariatur a voluptatem dignissimos maiores accusantium nobis tempora consequatur cumque quas ea doloribus deleniti.",
        "Quibusdam commodi laboriosam error temporibus iste ipsa soluta distinctio maiores ad totam beatae incidunt veritatis enim? Reiciendis voluptate assumenda quidem eos explicabo rerum. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod.",
      ],
    },
  ];

  return (
    <div id="carousel-section" className="carousel-section pad-none">
      <div className="container">
        {homeIntroData &&
            (homeIntroData?.who_we_are_video ||
              homeIntroData?.who_we_are_description) && (
            <div className="row d-flex align-items-stretch mt-5">
              {/* Left Column */}
              <div className="col-lg-6 bg-1 bg-grey p-5 d-flex flex-column justify-content-center">
                <div className="title-wrap mb-0">
                  <div className="section-title margin-bottom-40">
                    <h2 className="title text-uppercase mb-0">
                       {homeIntroData?.who_we_are_heading || (
                          <>
                            Who We Are<span className="theme-color"></span>
                          </>
                        )}
                    </h2>
                    <span className="section-border-bottom"></span>
                  </div>
                </div>
                <p className="mb-0">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: homeIntroData?.who_we_are_description,
                    }}
                  ></span>
                </p>
              </div>

              {/* Right Column */}
              <div className="col-lg-6 bg-2 p-0 div-bg-img d-flex justify-content-center align-items-center center-portrait-whoweare">
                {homeIntroData?.who_we_are_video ? (
                  <div
                    className="about-vedio-frame w-100"
                    dangerouslySetInnerHTML={{
                      __html: homeIntroData?.who_we_are_video.replace(
                        /src=\"([^\"]+)\"/,
                        (match, p1) => {
                          const newUrl = new URL(p1);
                          newUrl.searchParams.set("autoplay", "1");
                          newUrl.searchParams.set("rel", "0");
                          newUrl.searchParams.set("mute", "1");
                          return `src="${newUrl.toString()}"`;
                        }
                      ),
                    }}
                  />
                ) : (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      backgroundImage: `url(${homeIntroData?.image || "/assets/images/bg/bg-9.jpg"
                        })`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                )}
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default CenteredPortraitWoWeAre;
